import React, { FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GroupRule, ResponseData } from "../../../../../models";
import { deleteSetting } from "../../../../../services/delete.data.service";
import { getSettings } from "../../../../../services/get.data.service";
import SettingsDelete from "../../shared/settingsDelete";
import SettingsView from "../../shared/settingsView";
import { ResultsTableRowData, SettingsAction, SettingsParams, SettingsType } from "../types";
import GroupRuleForm from "./groupRuleForm";
import isDuplicate from "../../shared/helpers/isDuplicate";

const GroupRuleSettings: FC = () => {
    const { action, id }: SettingsParams = useParams();
    const [data, setData] = useState<GroupRule[] | null>([]);

    const loadData = (): void => {
        getSettings<GroupRule>("grouprules").then((response) => {
            setData(response.data);
        });
    };

    useEffect(() => {
        loadData();
    }, []);

    const existingGroupRule = data?.find((groupRule) => groupRule.groupRuleId === Number(id));

    const rows: ResultsTableRowData[] | null =
        data &&
        data.map((groupRule) => {
            const fromAddresses = groupRule.fromAddresses?.length ? groupRule.fromAddresses.join("; ") : "-";
            return {
                id: groupRule.groupRuleId,
                data: [
                    groupRule.name,
                    groupRule.emailAccount.emailAddress,
                    groupRule.emailAccount.mailboxFolderName || "Inbox",
                    groupRule.group.groupCode || "",
                    groupRule.precedence,
                    groupRule.mustMatchAllPatterns ? "Yes" : "No",
                    fromAddresses,
                    groupRule.searchPatterns?.length || 0,
                    <Link key={`delete-${groupRule.groupRuleId}`} to={`/system-settings/grouprules/delete/${groupRule.groupRuleId}`}>
                        Delete
                    </Link>,
                    <Link key={`list-${groupRule.groupRuleId}`} to={`/system-settings/grouprules/edit/${groupRule.groupRuleId}`}>
                        Edit
                    </Link>,
                ],
            };
        });

    return (
        <SettingsView
            headers={["Name", "Polling Address", "Folder", "Group", "Precedence", "Must Match All", "From Addresses", "Patterns", "", ""]}
            rows={rows}
            sortColumn={null}
            titleSingle="Group Rule"
            titlePlural="Group Rules"
            type={SettingsType.grouprules}
        >
            {data !== null && action !== SettingsAction.delete && (
                <GroupRuleForm
                    existingGroupRule={existingGroupRule}
                    isDuplicate={(value): boolean => isDuplicate(
                        data.map((item) => ({ id: item.groupRuleId, value: item.name })),
                        value,
                        Number(id)
                    )}
                    load={loadData}
                />
            )}
            {action === SettingsAction.delete && existingGroupRule !== undefined && (
                <SettingsDelete
                    message={`Are you sure you want to delete this group rule: ${existingGroupRule.emailAccount.emailAddress} - ${existingGroupRule.group.groupCode}?`}
                    onDelete={() => {
                        return deleteSetting("grouprules", existingGroupRule.groupRuleId)
                            .then((result: ResponseData<void>) => {
                                if (!result.success) {
                                    throw new Error("Failed to delete group rule.");
                                }

                                loadData();
                            });
                    }}
                />
            )}
        </SettingsView>
    );
};

export default GroupRuleSettings;
